import PageTitleComponent from "../../components/PageTitle";
import ShippingProviders from "../../components/Shipping/ShippingProviders";

export default function ShippingProvidersScreen(){
return <div>
    <PageTitleComponent title="Shipping Providers" />
    <ShippingProviders/>
</div>
}